/*! SuspendSupport site düzeltmeleri — 2026-10-13: ürün hero paneli + blog ilgili bağlantılar + müşteri yorumları (TR/EN). Kaynak ve geri alma: KURULUM_WEB.md */
/*! SuspendSupport · ürün sayfası "hero" panelini ürüne göre düzeltir (TR + EN) — v1
 *  Sorun: Tüm ürün sayfalarında aynı dört etiket (Trademark / Copyright / Suspected counterfeit / Patent) ve
 *  aynı dört satırlık panel vardı; çoğu ürünle ilgisizdi.
 *  Çözüm: Sayfadaki ürüne bakar; sol taraftaki 4 etiketi ve sağdaki paneldeki 4 satırı (simge · başlık · alt yazı)
 *  ürüne uygun olanlarla değiştirir. Durum rozetleri, pencere başlığı, süreç çubuğu, düğmeler olduğu gibi kalır.
 *  Güvenli: ürün tanınmazsa ya da sayfa beklenen yapıda değilse HİÇBİR ŞEY yapmaz. Fikri mülkiyet ürünü (Trademark… doğru)
 *  değiştirilmez. İki kez çalışmaz.
 *  Kullanım: theme.liquid içinde </body> öncesine <script> ile yapıştırılır (KURULUM_WEB.md).
 */
(function () {
  "use strict";
  var V = {
    // anahtar: ürün adresinin (handle) içinde geçen ASCII parça · c: 4 etiket · r: 4 satır [simge, başlık, alt yazı]
    "section-3": {
      tr: { c: ["Dürüst ticaret", "Doğru ürün bilgisi", "Veri güvenliği", "Müşteri hakları"],
            r: [["§", "Dürüst ticaret", "Politika incelemesi"], ["!", "Doğru ürün bilgisi", "Listeleme kontrolü"], ["#", "Veri güvenliği", "Hesap ve veri yönetimi"], ["*", "Müşteri hakları", "Müşteri deneyimi"]] },
      en: { c: ["Honest trade", "Accurate product info", "Data security", "Customer rights"],
            r: [["§", "Honest trade", "Policy review"], ["!", "Accurate product info", "Listing check"], ["#", "Data security", "Account and data handling"], ["*", "Customer rights", "Buyer experience"]] }
    },
    "adil-fiyat": {
      tr: { c: ["Aşırı yüksek fiyat", "Dış kanal kıyası", "Fiyat geçmişi", "Fiyat düzeltme"],
            r: [["$", "Aşırı yüksek fiyat", "Amazon bildirimi"], ["%", "Dış kanal kıyası", "Amazon dışı fiyatlar"], ["#", "Fiyat geçmişi", "Ürün bazlı inceleme"], ["§", "Fiyat düzeltme", "Appeal planı"]] },
      en: { c: ["Excessive price", "Off-Amazon comparison", "Price history", "Price correction"],
            r: [["$", "Excessive price", "Amazon notice"], ["%", "Off-Amazon comparison", "Outside-channel prices"], ["#", "Price history", "Per-product review"], ["§", "Price correction", "Appeal plan"]] }
    },
    "account-review": {
      tr: { c: ["Teslimat performansı", "Takip numaraları", "Politika uyumu", "Belge talebi"],
            r: [["%", "Teslimat performansı", "Sipariş incelemesi"], ["#", "Takip numaraları", "Kargo kayıtları"], ["§", "Politika uyumu", "Hesap taraması"], ["!", "Belge talebi", "Fatura ve kanıt"]] },
      en: { c: ["Delivery performance", "Tracking numbers", "Policy compliance", "Document request"],
            r: [["%", "Delivery performance", "Order review"], ["#", "Tracking numbers", "Carrier records"], ["§", "Policy compliance", "Account scan"], ["!", "Document request", "Invoices and proof"]] }
    },
    "fon-kurtarma": {
      tr: { c: ["Bekleyen bakiye", "Hesap durumu", "Belge hazırlığı", "Amazon ile iletişim"],
            r: [["$", "Bekleyen bakiye", "Bakiye tespiti"], ["§", "Süreç değerlendirmesi", "Hesap durumu"], ["#", "Belge hazırlığı", "Fatura ve kimlik"], ["@", "Amazon ile iletişim", "Talep ve takip"]] },
      en: { c: ["Held balance", "Account status", "Document preparation", "Contact with Amazon"],
            r: [["$", "Held balance", "Balance check"], ["§", "Process review", "Account status"], ["#", "Document preparation", "Invoices and ID"], ["@", "Contact with Amazon", "Request and follow-up"]] }
    },
    "orcun-uyar-ile-birebir": {
      tr: { c: ["Hesap analizi", "Strateji", "Soru ve cevap", "Kişiye özel tavsiye"],
            r: [["?", "Soru ve cevap", "Canlı görüşme"], ["=", "Durum analizi", "Hesabınıza özel"], ["*", "Strateji", "Yol haritası"], ["+", "Kişiye özel tavsiye", "Sonraki adımlar"]] },
      en: { c: ["Account review", "Strategy", "Questions and answers", "Personal advice"],
            r: [["?", "Questions and answers", "Live session"], ["=", "Situation analysis", "Specific to your account"], ["*", "Strategy", "Roadmap"], ["+", "Personal advice", "Next steps"]] }
    },
    "kuzey-amerika": {
      tr: { c: ["ABD", "Kanada", "Meksika", "Şirket belgeleri"],
            r: [["+", "ABD pazarı", "Kayıt ve doğrulama"], ["+", "Kanada pazarı", "Kayıt ve doğrulama"], ["+", "Meksika pazarı", "Kayıt ve doğrulama"], ["§", "Şirket belgeleri", "Kimlik doğrulaması"]] },
      en: { c: ["USA", "Canada", "Mexico", "Company documents"],
            r: [["+", "US marketplace", "Registration and verification"], ["+", "Canadian marketplace", "Registration and verification"], ["+", "Mexican marketplace", "Registration and verification"], ["§", "Company documents", "Identity verification"]] }
    },
    "avrupa-hesap": {
      tr: { c: ["İngiltere", "Almanya", "Fransa", "Şirket belgeleri"],
            r: [["+", "İngiltere pazarı", "Kayıt ve doğrulama"], ["+", "Almanya pazarı", "Kayıt ve doğrulama"], ["+", "Fransa pazarı", "Kayıt ve doğrulama"], ["§", "Şirket belgeleri", "Kimlik doğrulaması"]] },
      en: { c: ["United Kingdom", "Germany", "France", "Company documents"],
            r: [["+", "UK marketplace", "Registration and verification"], ["+", "German marketplace", "Registration and verification"], ["+", "French marketplace", "Registration and verification"], ["§", "Company documents", "Identity verification"]] }
    },
    "kapali-kategori": {
      tr: { c: ["Kategori onayı", "Başvuru belgeleri", "Ürün uygunluğu", "Onay takibi"],
            r: [["§", "Kategori onayı", "Amazon başvurusu"], ["#", "Başvuru belgeleri", "Fatura ve sertifika"], ["!", "Ürün uygunluğu", "Politika kontrolü"], ["@", "Onay takibi", "Süreç yönetimi"]] },
      en: { c: ["Category approval", "Application documents", "Product eligibility", "Approval follow-up"],
            r: [["§", "Category approval", "Amazon application"], ["#", "Application documents", "Invoices and certificates"], ["!", "Product eligibility", "Policy check"], ["@", "Approval follow-up", "Case management"]] }
    },
    "tek-appeal": {
      tr: { c: ["Tek seferlik appeal", "Sebep analizi", "Eylem planı", "Belge desteği"],
            r: [["!", "Sebep analizi", "Hesap incelemesi"], ["§", "Eylem planı", "Appeal metni"], ["#", "Belge desteği", "Fatura ve kanıt"], ["@", "Appeal gönderimi", "Tek deneme"]] },
      en: { c: ["One-time appeal", "Root-cause analysis", "Plan of action", "Document support"],
            r: [["!", "Root-cause analysis", "Account review"], ["§", "Plan of action", "Appeal text"], ["#", "Document support", "Invoices and proof"], ["@", "Appeal submission", "Single attempt"]] }
    },
    "liskilendirme": {
      tr: { c: ["İlişkili hesap", "Ortak bilgiler", "Cihaz ve ağ bilgisi", "Eylem planı"],
            r: [["&", "İlişkili hesap", "Amazon bildirimi"], ["=", "Ortak bilgiler", "Adres ve ödeme"], ["#", "Cihaz ve ağ bilgisi", "Bağlantı analizi"], ["§", "Eylem planı", "Appeal hazırlığı"]] },
      en: { c: ["Related account", "Shared details", "Device and network", "Plan of action"],
            r: [["&", "Related account", "Amazon notice"], ["=", "Shared details", "Address and payment"], ["#", "Device and network", "Link analysis"], ["§", "Plan of action", "Appeal preparation"]] }
    },
    "hizli-satis": {
      tr: { c: ["Satış hızı", "Aylık hacim", "Hesap limiti", "Doğrulama belgeleri"],
            r: [["%", "Satış hızı", "Amazon bildirimi"], ["$", "Aylık hacim", "Giriş-çıkış tutarı"], ["!", "Hesap limiti", "Risk değerlendirmesi"], ["#", "Doğrulama belgeleri", "Fatura ve kanıt"]] },
      en: { c: ["Sales velocity", "Monthly volume", "Account limit", "Verification documents"],
            r: [["%", "Sales velocity", "Amazon notice"], ["$", "Monthly volume", "Money in and out"], ["!", "Account limit", "Risk assessment"], ["#", "Verification documents", "Invoices and proof"]] }
    },
    "acilis-suspendi": {
      tr: { c: ["Kimlik doğrulama", "Adres belgesi", "Banka ve kart", "Yeniden inceleme"],
            r: [["?", "Kimlik doğrulama", "Doğrulama başarısız"], ["#", "Adres belgesi", "Belge kontrolü"], ["$", "Banka ve kart", "Hesap bilgileri"], ["@", "Yeniden inceleme", "Appeal ve takip"]] },
      en: { c: ["Identity verification", "Address proof", "Bank and card", "Re-review"],
            r: [["?", "Identity verification", "Verification failed"], ["#", "Address proof", "Document check"], ["$", "Bank and card", "Account details"], ["@", "Re-review", "Appeal and follow-up"]] }
    },
    "arama-hizmeti": {
      tr: { c: ["Amazon ile görüşme", "İngilizce iletişim", "Vaka takibi", "Teknik destek"],
            r: [["@", "Amazon ile görüşme", "Sizin adınıza"], ["?", "İngilizce iletişim", "Yabancı dil desteği"], ["#", "Vaka takibi", "Durum güncellemesi"], ["+", "Teknik destek", "Süreç yönetimi"]] },
      en: { c: ["Call with Amazon", "English communication", "Case follow-up", "Technical support"],
            r: [["@", "Call with Amazon", "On your behalf"], ["?", "English communication", "Language support"], ["#", "Case follow-up", "Status updates"], ["+", "Technical support", "Case handling"]] }
    },
    "drop-shipping": {
      tr: { c: ["Tedarikçi belgeleri", "Satış izni", "Fatura doğrulama", "Politika uyumu"],
            r: [["#", "Tedarikçi belgeleri", "Resmi satış izni"], ["§", "Satış izni", "Yetki kontrolü"], ["$", "Fatura doğrulama", "Fatura incelemesi"], ["!", "Politika uyumu", "Drop shipping kuralları"]] },
      en: { c: ["Supplier documents", "Sales authorization", "Invoice verification", "Policy compliance"],
            r: [["#", "Supplier documents", "Official sales permission"], ["§", "Sales authorization", "Authorization check"], ["$", "Invoice verification", "Invoice review"], ["!", "Policy compliance", "Drop shipping rules"]] }
    },
    "gec-gonderim": {
      tr: { c: ["Geç gönderim oranı", "Konfirme süresi", "72 saat savunma", "Kargo takibi"],
            r: [["%", "Geç gönderim oranı", "Amazon bildirimi"], ["#", "Konfirme süresi", "Sipariş kayıtları"], ["§", "Yazılı savunma", "72 saat süre"], ["@", "Kargo takibi", "Takip numaraları"]] },
      en: { c: ["Late shipment rate", "Confirmation time", "72-hour response", "Shipment tracking"],
            r: [["%", "Late shipment rate", "Amazon notice"], ["#", "Confirmation time", "Order records"], ["§", "Written response", "72-hour deadline"], ["@", "Shipment tracking", "Tracking numbers"]] }
    },
    "hesap-sagligi": {
      tr: { c: ["Hizmet performansı", "Politika uyumu", "Gönderim performansı", "Hesap sağlığı"],
            r: [["%", "Hizmet performansı", "Müşteri memnuniyeti"], ["§", "Politika uyumu", "Politika ihlalleri"], ["#", "Gönderim performansı", "Teslimat metrikleri"], ["*", "Hesap sağlığı", "Genel değerlendirme"]] },
      en: { c: ["Service performance", "Policy compliance", "Shipping performance", "Account health"],
            r: [["%", "Service performance", "Customer satisfaction"], ["§", "Policy compliance", "Policy violations"], ["#", "Shipping performance", "Delivery metrics"], ["*", "Account health", "Overall assessment"]] }
    },
    "yasakli": {
      tr: { c: ["Yasaklı ürünler", "Kısıtlı kategoriler", "Ülke mevzuatı", "Listeleme temizliği"],
            r: [["!", "Yasaklı ürün", "Amazon bildirimi"], ["§", "Kısıtlı kategori", "Onay gereksinimi"], ["#", "Ülke mevzuatı", "Pazar kuralları"], ["+", "Listeleme temizliği", "Envanter kontrolü"]] },
      en: { c: ["Prohibited products", "Restricted categories", "Local regulations", "Listing cleanup"],
            r: [["!", "Prohibited product", "Amazon notice"], ["§", "Restricted category", "Approval requirement"], ["#", "Local regulations", "Marketplace rules"], ["+", "Listing cleanup", "Inventory check"]] }
    },
    "ptal-orani": {
      tr: { c: ["İptal oranı", "Satıcı kaynaklı iptaller", "Stok senkronu", "Eylem planı"],
            r: [["%", "İptal oranı", "Amazon hedef eşiği"], ["!", "Satıcı kaynaklı iptaller", "Sipariş kayıtları"], ["#", "Stok senkronu", "Envanter doğruluğu"], ["§", "Eylem planı", "Appeal hazırlığı"]] },
      en: { c: ["Cancellation rate", "Seller-initiated cancellations", "Inventory sync", "Plan of action"],
            r: [["%", "Cancellation rate", "Amazon target threshold"], ["!", "Seller-initiated cancellations", "Order records"], ["#", "Inventory sync", "Inventory accuracy"], ["§", "Plan of action", "Appeal preparation"]] }
    },
    "kusur-orani": {
      tr: { c: ["Olumsuz geri bildirim", "A-to-Z talepleri", "Kart itirazları", "Kusur oranı"],
            r: [["!", "Olumsuz geri bildirim", "Müşteri yorumları"], ["?", "A-to-Z talepleri", "Müşteri talepleri"], ["$", "Kart itirazları", "Chargeback kayıtları"], ["%", "Kusur oranı", "Amazon eşiği"]] },
      en: { c: ["Negative feedback", "A-to-z claims", "Chargebacks", "Defect rate"],
            r: [["!", "Negative feedback", "Customer feedback"], ["?", "A-to-z claims", "Buyer claims"], ["$", "Chargebacks", "Chargeback records"], ["%", "Defect rate", "Amazon threshold"]] }
    },
    "3-asin": {
      tr: { c: ["Sahte ürün şikayeti", "Tedarik belgeleri", "Marka yetkisi", "Eylem planı"],
            r: [["!", "Sahte ürün şikayeti", "Amazon bildirimi"], ["#", "Tedarik belgeleri", "Fatura ve tedarikçi"], ["§", "Marka yetkisi", "Yetki belgesi"], ["+", "Eylem planı", "Appeal hazırlığı"]] },
      en: { c: ["Inauthentic-item complaint", "Sourcing documents", "Brand authorization", "Plan of action"],
            r: [["!", "Inauthentic-item complaint", "Amazon notice"], ["#", "Sourcing documents", "Invoices and supplier"], ["§", "Brand authorization", "Authorization letter"], ["+", "Plan of action", "Appeal preparation"]] }
    }
  };
  // fikri mülkiyet ürünü: bilinçli olarak yok (Trademark / Copyright / Suspected counterfeit / Patent o ürüne uygun)

  var ORIJINAL = ["Trademark", "Copyright", "Suspected counterfeit", "Patent"];

  function urunBul(handleDuz) {
    var anahtarlar = Object.keys(V);
    for (var i = 0; i < anahtarlar.length; i++) {
      if (handleDuz.indexOf(anahtarlar[i]) !== -1) return anahtarlar[i];
    }
    return null;
  }

  // doc: belge (canlı sayfada document; testte ayrıştırılmış belge). yol: /products/... ya da /en/products/...
  function uygula(doc, yol, dil) {
    var m = /\/products\/([^\/?#]+)/.exec(yol || "");
    if (!m) return "urun-degil";
    var handle;
    try { handle = decodeURIComponent(m[1]); } catch (e) { handle = m[1]; }
    // "i" + birleşik nokta gibi harfleri sadeleştir: eşleşme yalnızca ASCII parçalarla yapılır
    var duz = handle.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    var anahtar = urunBul(duz);
    if (!anahtar) return "tanimsiz-urun";
    var hero = doc.querySelector(".ss-hero");
    if (!hero) return "hero-yok";
    if (hero.getAttribute("data-ssx")) return "zaten-yapildi";
    var yapraklar = [].slice.call(hero.querySelectorAll("*")).filter(function (e) {
      return !e.children.length && e.textContent.replace(/\s+/g, "") !== "";
    });
    // Beklenen sıra: [başlık, paragraf, 4 etiket, 2 düğme, pencere başlığı, 4×(simge, başlık, alt yazı, durum), ...]
    if (yapraklar.length < 25) return "yapi-farkli";
    for (var k = 0; k < 4; k++) {
      if (yapraklar[2 + k].textContent.trim() !== ORIJINAL[k]) return "yapi-farkli";
      if (yapraklar[10 + 4 * k].textContent.trim() !== ORIJINAL[k]) return "yapi-farkli";
    }
    var d = V[anahtar][dil === "en" ? "en" : "tr"];
    for (var i = 0; i < 4; i++) {
      yapraklar[2 + i].textContent = d.c[i];
      var b = 9 + 4 * i; // simge
      yapraklar[b].textContent = d.r[i][0];
      yapraklar[b + 1].textContent = d.r[i][1];
      yapraklar[b + 2].textContent = d.r[i][2];
    }
    hero.setAttribute("data-ssx", "1");
    return "ok";
  }

  if (typeof window !== "undefined" && typeof document !== "undefined" && !window.__ssHeroTest) {
    var calistir = function () {
      try {
        var dil = (document.documentElement.getAttribute("lang") || "tr").toLowerCase().indexOf("en") === 0 ? "en" : "tr";
        uygula(document, location.pathname, dil);
      } catch (e) {}
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", calistir);
    else calistir();
  }
  if (typeof window !== "undefined") window.__ssHeroUygula = uygula;
})();

/*! SuspendSupport · Blog yazılarının sonuna "İlgili bağlantılar" bloğu (TR + EN) — v1
 *  Her yazının sonuna (etiketlerden hemen önce) o yazıya özel seçilmiş 3 ilgili yazı + 2-3 ilgili hizmet bağlantısı ve
 *  WhatsApp çağrısı ekler. Bağlantılar gerçek <a href> olarak eklenir (arama motorları izler).
 *  - Yazıda zaten bağlantısı olan yazılar blokta tekrarlanmaz.
 *  - Haritada olmayan yeni bir yazı eklenirse genel bir blok gösterilir (bozulmaz).
 *  - Yazı sayfası beklenen yapıda değilse HİÇBİR ŞEY yapmaz; iki kez eklenmez.
 *  Kullanım: theme.liquid içinde </body> öncesine <script> ile yapıştırılır (KURULUM_WEB.md).
 */
(function () {
  "use strict";
  var WA = "https://wa.me/905541716182";
  var TOPLAM_URUN = 3;

  // Yazılar: handle -> [Türkçe başlık, İngilizce başlık]
  var Y = {
    "amazon-related-accounts-iliskilendirme-suspendi": ["Amazon İlişkilendirme (Related Accounts) Suspendi Nedir?", "What Is an Amazon Related Accounts Suspension?"],
    "amazon-suspend-ne-kadar-surer": ["Amazon Suspend Ne Kadar Sürer? Süreci Etkileyen Faktörler", "How Long Does an Amazon Suspension Take? Factors That Affect the Process"],
    "amazon-hesabim-kapandi-ne-yapmaliyim": ["Amazon Hesabım Kapandı: Ne Anlama Gelir, Ne Yapmalıyım?", "My Amazon Account Was Closed: What Does It Mean and What Should I Do?"],
    "amazon-suspend-nedir": ["Amazon Suspend Nedir? Türleri, Nedenleri ve Çözüm Süreci", "What Is an Amazon Suspension? Types, Causes and the Resolution Process"],
    "amazon-hesabim-suspend-oldu-ilk-adimlar": ["Amazon Hesabım Suspend Oldu: İlk Gün Ne Yapmalıyım?", "My Amazon Account Got Suspended: What Should I Do on Day One?"],
    "amazon-plan-of-action-poa-nasil-yazilir": ["Amazon Plan of Action (POA) Nasıl Yazılır? Üç Bölüm ve Sık Yapılan Hatalar", "How to Write an Amazon Plan of Action (POA)? Three Sections and Common Mistakes"],
    "amazon-hesap-sagligi-account-health-nedir": ["Amazon Hesap Sağlığı (Account Health) Nedir? Nasıl Takip Edilir?", "What Is Amazon Account Health? How to Monitor It"],
    "drop-shipping-saticilari-icin-sellerrunning": ["Drop Shipping satıcıları için: SELLERRUNNING", "For Drop Shipping Sellers: SellerRunning"],
    "amazon-adil-fiyatlandirma-politikasi": ["Amazon Adil Fiyatlandırma Politikası", "Amazon Fair Pricing Policy"],
    "amazonda-fikri-mulkiyet": ["Amazon'da Fikri Mülkiyet!", "Intellectual Property on Amazon"],
    "amazon-neden-suspend-ediyor": ["Amazon neden Suspend ediyor?", "Why Does Amazon Suspend Accounts?"],
    "seller-code-of-conduct-nedir": ["Seller Code of Conduct Nedir?", "What Is the Seller Code of Conduct?"],
    "amazonda-drop-shipping": ["Amazon'da Drop Shipping", "Drop Shipping on Amazon"],
    "yas-kisitlamali-urunler-age-restricted-products": ["Yaş Kısıtlamalı Ürünler - Age Restricted Products", "Age-Restricted Products on Amazon (Age Verification on Delivery)"]
  };
  var A = Object.keys(Y);
  var K = function (parca) { return A.filter(function (h) { return h.indexOf(parca) !== -1; })[0]; };
  var yBilgi = K("amazon-suspend-nedir"), yIlk = K("ilk-adimlar"), yPoa = K("plan-of-action"), ySure = K("ne-kadar-surer"),
      yKapandi = K("hesabim-kapandi"), yNeden = K("neden-suspend"), ySellerCoc = K("seller-code"), yHs = K("hesap-sagligi"),
      yDrop = K("amazonda-drop"), yDropSr = K("sellerrunning");

  // Hizmetler (ürünler): anahtar -> [ürün adresi (handle), Türkçe ad, İngilizce ad]
  var H = {
    iliski: ["i\u0307liskilendirme-suspendi-related-accounts", "İlişkilendirme (Related Accounts) suspendi", "Related accounts suspension"],
    appeal: ["tek-appeal-hizmeti", "Tek appeal denemesi", "Single appeal attempt"],
    birebir: ["orcun-uyar-ile-birebir-gorusme", "Orçun UYAR ile birebir görüşme", "One-on-one consultation with Orçun UYAR"],
    fon: ["fon-kurtarma-hizmeti", "Fon kurtarma hizmeti", "Fund recovery service"],
    inceleme: ["hesap-i\u0307nceleme-account-review", "Hesap inceleme (Account Review)", "Account review"],
    arama: ["arama-hizmeti-call-service", "Arama hizmeti (Call Service)", "Call service"],
    saglik: ["hesap-sagligi-i\u0307nceleme", "Hesap sağlığı inceleme", "Account health review"],
    kusur: ["siparis-kusur-orani-order-defect-rate", "Sipariş kusur oranı", "Order defect rate"],
    gec: ["gec-gonderim-sorunlari-late-shipment-issues", "Geç gönderim sorunları", "Late shipment issues"],
    drop: ["drop-shipping-politika-i\u0307hlali-drop-shipping-policy-violation", "Drop shipping politika ihlali", "Drop shipping policy violation"],
    adil: ["adil-fiyatlandirma-politikasi-i\u0307hlali-fair-pricing-issues", "Adil fiyatlandırma ihlali", "Fair pricing issues"],
    fikri: ["fikri-mulkiyet-intellectual-property-violations", "Fikri mülkiyet ihlalleri", "Intellectual property violations"],
    asin3: ["3-asin-inauthentic-item-issue", "3 ASIN sahte ürün (Inauthentic Item) sorunu", "Inauthentic item issue"],
    sec3: ["section-3-satici-ahlak-politikasi", "Section 3 ihlali", "Section 3 violation"],
    yasakli: ["yasaklikisitli-urunler-restricted-products", "Yasaklı / kısıtlı ürünler", "Restricted products"],
    kapali: ["kapali-kategori-acilisi-banned-category-activation", "Kapalı kategori açılışı", "Banned category activation"]
  };

  // Her yazı için: ilgili yazılar (3) ve ilgili hizmetler (2-3)
  var R = {};
  R[K("related-accounts")] = { y: [yBilgi, yPoa, yIlk], h: ["iliski", "appeal", "birebir"] };
  R[ySure] = { y: [yBilgi, yIlk, yPoa], h: ["appeal", "birebir", "fon"] };
  R[yKapandi] = { y: [yIlk, yBilgi, yNeden], h: ["appeal", "fon", "birebir"] };
  R[yBilgi] = { y: [yNeden, yIlk, ySure], h: ["birebir", "appeal", "inceleme"] };
  R[yIlk] = { y: [yPoa, ySure, yKapandi], h: ["appeal", "birebir", "arama"] };
  R[yPoa] = { y: [yIlk, yHs, yBilgi], h: ["appeal", "birebir"] };
  R[yHs] = { y: [ySellerCoc, yNeden, yPoa], h: ["saglik", "kusur", "gec"] };
  R[yDropSr] = { y: [yDrop, ySellerCoc, yNeden], h: ["drop", "birebir"] };
  R[K("adil-fiyat")] = { y: [ySellerCoc, yNeden, yHs], h: ["adil", "appeal"] };
  R[K("fikri-mulkiyet")] = { y: [yNeden, ySellerCoc, yPoa], h: ["fikri", "asin3", "appeal"] };
  R[yNeden] = { y: [yBilgi, ySellerCoc, yHs], h: ["birebir", "inceleme", "appeal"] };
  R[ySellerCoc] = { y: [yNeden, yHs, yBilgi], h: ["sec3", "inceleme", "birebir"] };
  R[yDrop] = { y: [yDropSr, ySellerCoc, yNeden], h: ["drop", "birebir"] };
  R[K("yas-kisitlamali")] = { y: [ySellerCoc, yNeden, yHs], h: ["yasakli", "kapali", "birebir"] };
  var VARSAYILAN = { y: [yBilgi, yIlk, yPoa], h: ["birebir", "appeal"] };

  var METIN = {
    tr: { baslik: "İlgili bağlantılar", yazilar: "İlgili yazılar", hizmetler: "İlgili hizmetler", soru: "Durumunuzu birlikte inceleyelim.", wa: "WhatsApp ile yazın", etiket: "İlgili bağlantılar" },
    en: { baslik: "Related links", yazilar: "Related articles", hizmetler: "Related services", soru: "Let us review your situation together.", wa: "Message us on WhatsApp", etiket: "Related links" }
  };

  var CSS = ".ss-il{margin:40px 0 8px;padding:24px 26px;border:1px solid #D8E4EF;border-radius:16px;background:linear-gradient(180deg,#F7FAFD,#fff);color:#0E2A47}" +
    ".ss-il h2{margin:0 0 14px;font-size:1.25em;line-height:1.25;color:#0E2A47}" +
    ".ss-il-iki{display:grid;grid-template-columns:1fr 1fr;gap:22px}" +
    ".ss-il h3{margin:0 0 8px;font-size:.78em;letter-spacing:.08em;text-transform:uppercase;color:#44566A;font-weight:700}" +
    ".ss-il ul{list-style:none;margin:0;padding:0}" +
    ".ss-il li{margin:0;border-top:1px solid #E3ECF4}" +
    ".ss-il li:first-child{border-top:0}" +
    ".ss-il a.ss-il-a{display:flex;gap:10px;align-items:baseline;padding:9px 0;color:#1878B9;text-decoration:none;font-weight:600;line-height:1.4}" +
    ".ss-il a.ss-il-a:hover{color:#0E2A47;text-decoration:underline}" +
    ".ss-il a.ss-il-a:before{content:'\\2192';flex:none;color:#1878B9}" +
    ".ss-il-alt{display:flex;flex-wrap:wrap;align-items:center;gap:12px 18px;margin-top:18px;padding-top:16px;border-top:1px solid #D8E4EF}" +
    ".ss-il-alt span{color:#44566A;flex:1 1 220px}" +
    ".ss-il a.ss-il-wa{display:inline-block;padding:10px 18px;border-radius:10px;background:#1878B9;color:#fff;font-weight:700;text-decoration:none}" +
    ".ss-il a.ss-il-wa:hover{background:#0E2A47;color:#fff}" +
    "@media (max-width:700px){.ss-il{padding:18px 16px;margin-top:28px}.ss-il-iki{grid-template-columns:1fr;gap:16px}}";

  function olustur(doc, yol, dil) {
    var icerik = doc.querySelector(".article--content");
    if (!icerik) return "yapi-farkli";
    if (doc.querySelector(".ss-il")) return "zaten-yapildi";
    var on = dil === "en" ? "/en" : "";
    var m = /\/blogs\/[^\/]+\/([^\/?#]+)/.exec(yol || "");
    var kendi = m ? decodeURIComponent(m[1]) : "";
    var tanimli = R[kendi] || VARSAYILAN;
    var di = dil === "en" ? 1 : 0;
    var t = METIN[dil === "en" ? "en" : "tr"];

    // yazıda zaten bağlantısı olan yazıları ele
    var mevcut = [].slice.call(icerik.querySelectorAll("a[href]")).map(function (a) { return a.getAttribute("href") || ""; }).join(" ");
    var yazilar = tanimli.y.filter(function (h) { return h && h !== kendi && mevcut.indexOf("/" + h) === -1; });
    // çok eleme olursa en az iki yazıya tamamla (önce varsayılanlar, sonra diğerleri; yazıda bağlantısı olanlar hariç)
    if (yazilar.length < 2) {
      VARSAYILAN.y.concat(A).forEach(function (h) {
        if (yazilar.length < 2 && h && h !== kendi && yazilar.indexOf(h) === -1 && mevcut.indexOf("/" + h) === -1) yazilar.push(h);
      });
    }
    yazilar = yazilar.slice(0, 3);
    var hizmetler = tanimli.h.slice(0, TOPLAM_URUN);

    function li(href, ad) {
      var el = doc.createElement("li");
      var a = doc.createElement("a");
      a.className = "ss-il-a";
      a.setAttribute("href", href);
      a.textContent = ad;
      el.appendChild(a);
      return el;
    }
    var kutu = doc.createElement("nav");
    kutu.className = "ss-il";
    kutu.setAttribute("aria-label", t.etiket);
    var b = doc.createElement("h2");
    b.textContent = t.baslik;
    kutu.appendChild(b);
    var iki = doc.createElement("div");
    iki.className = "ss-il-iki";

    var s1 = doc.createElement("div");
    var h31 = doc.createElement("h3");
    h31.textContent = t.yazilar;
    s1.appendChild(h31);
    var u1 = doc.createElement("ul");
    yazilar.forEach(function (h) { u1.appendChild(li(on + "/blogs/news/" + h, Y[h][di])); });
    s1.appendChild(u1);

    var s2 = doc.createElement("div");
    var h32 = doc.createElement("h3");
    h32.textContent = t.hizmetler;
    s2.appendChild(h32);
    var u2 = doc.createElement("ul");
    hizmetler.forEach(function (k) { u2.appendChild(li(on + "/products/" + encodeURIComponent(H[k][0]), H[k][1 + di])); });
    s2.appendChild(u2);

    iki.appendChild(s1);
    iki.appendChild(s2);
    kutu.appendChild(iki);

    var alt = doc.createElement("div");
    alt.className = "ss-il-alt";
    var sp = doc.createElement("span");
    sp.textContent = t.soru;
    var wa = doc.createElement("a");
    wa.className = "ss-il-wa";
    wa.setAttribute("href", WA);
    wa.setAttribute("rel", "noopener");
    wa.setAttribute("target", "_blank");
    wa.textContent = t.wa;
    alt.appendChild(sp);
    alt.appendChild(wa);
    kutu.appendChild(alt);

    var st = doc.createElement("style");
    st.textContent = CSS;
    kutu.appendChild(st);
    icerik.parentNode.insertBefore(kutu, icerik.nextSibling);
    return "ok";
  }

  if (typeof window !== "undefined" && typeof document !== "undefined" && !window.__ssIlgiliTest) {
    var calistir = function () {
      try {
        var dil = (document.documentElement.getAttribute("lang") || "tr").toLowerCase().indexOf("en") === 0 ? "en" : "tr";
        olustur(document, location.pathname, dil);
      } catch (e) {}
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", calistir);
    else calistir();
  }
  if (typeof window !== "undefined") window.__ssIlgiliUygula = olustur;
  if (typeof module !== "undefined") module.exports = { olustur: olustur, R: R, Y: Y, H: H };
})();

/*! SuspendSupport · Müşteri yorumları bölümü (TR + EN) — v1
 *  Sayfada  <div id="ss-yorumlar"></div>  bulunan yere yorum kartlarını çizer.
 *  - Yorumlar aşağıdaki YORUMLAR listesindedir. LİSTE BOŞSA BÖLÜM HİÇ GÖRÜNMEZ (uydurma yorum gösterilmez).
 *  - Yeni yorum eklemek için listeye bir satır eklemek yeterlidir (örnek aşağıda, yorum satırı içinde).
 *  - Yalnızca GERÇEK müşteri yorumları ve müşterinin YAZILI İZNİYLE eklenmelidir (WhatsApp şablonu: YORUM_TOPLAMA.md).
 *  - Metinler textContent ile yazılır (güvenli); renkler sitedeki mavi/lacivert düzene uyar.
 *  - Masaüstünde kartlar ızgara, telefonda yana kaydırmalı satır ve "1/N" sayacı.
 */
(function () {
  "use strict";

  // ---- BURAYA GERÇEK YORUMLARI EKLEYİN ------------------------------------------------------------
  // Biçim (virgülle ayırarak çoğaltın):
  //   { ad: "A.K.", puan: 5, metin: "Yorum metni (Türkçe)", metin_en: "English text (isteğe bağlı)",
  //     pazar: "Amazon.com", paket: "20.000 ASIN", tarih: "2026-10", one: false }
  //   ad    : yalnızca baş harfler (müşteri başka türlü izin vermediyse)
  //   puan  : 1-5 tam sayı
  //   pazar, paket, tarih : isteğe bağlı küçük bilgi satırı (tarih "YYYY-AA")
  //   one   : true yapılan yorum, ilk sıradaki koyu renkli "öne çıkan" kart olur (en fazla 1)
  var YORUMLAR = [];
  // --------------------------------------------------------------------------------------------------

  var METIN = {
    tr: { baslik: "Müşterilerimiz ne diyor?", alt: "Gerçek müşterilerimizin izniyle paylaşılan değerlendirmeler.", devam: "devamını oku", kapat: "daha az göster", puan: "5 üzerinden", ort: "ortalama", yorum: "değerlendirme" },
    en: { baslik: "What our customers say", alt: "Reviews shared with the permission of real customers.", devam: "read more", kapat: "show less", puan: "out of 5", ort: "average", yorum: "reviews" }
  };
  var AYLAR = {
    tr: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
    en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  };
  var CSS =
    "#ss-yorumlar{max-width:1200px;margin:48px auto;padding:0 16px;color:#0E2A47}" +
    "#ss-yorumlar .ssy-ust{display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:10px 24px;margin-bottom:22px}" +
    "#ss-yorumlar h2{margin:0;font-size:1.7em;line-height:1.2;color:#0E2A47}" +
    "#ss-yorumlar .ssy-alt{margin:6px 0 0;color:#44566A;font-size:.95em}" +
    "#ss-yorumlar .ssy-ort{display:flex;align-items:center;gap:10px;color:#44566A;font-size:.95em}" +
    "#ss-yorumlar .ssy-ort b{font-size:1.9em;color:#0E2A47;line-height:1}" +
    "#ss-yorumlar .ssy-izgara{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;align-items:start}" +
    "#ss-yorumlar .ssy-kart{background:#fff;border:1px solid #D8E4EF;border-radius:16px;padding:20px 20px 16px;display:flex;flex-direction:column;gap:12px;box-shadow:0 2px 10px rgba(14,42,71,.05)}" +
    "#ss-yorumlar .ssy-kart.ssy-one{background:linear-gradient(145deg,#0E2A47,#1878B9);border-color:transparent;color:#fff}" +
    "#ss-yorumlar .ssy-yildiz{display:flex;gap:2px;line-height:0}" +
    "#ss-yorumlar .ssy-yildiz svg{width:18px;height:18px}" +
    "#ss-yorumlar .ssy-metin{margin:0;line-height:1.55;font-size:.98em;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:5}" +
    "#ss-yorumlar .ssy-metin.ssy-acik{display:block;-webkit-line-clamp:unset}" +
    "#ss-yorumlar .ssy-devam{align-self:flex-start;background:none;border:0;padding:0;font:inherit;font-weight:700;color:#1878B9;cursor:pointer}" +
    "#ss-yorumlar .ssy-one .ssy-devam{color:#FFC93C}" +
    "#ss-yorumlar .ssy-yazar{display:flex;align-items:center;gap:12px;margin-top:auto;padding-top:12px;border-top:1px solid #E3ECF4}" +
    "#ss-yorumlar .ssy-one .ssy-yazar{border-top-color:rgba(255,255,255,.25)}" +
    "#ss-yorumlar .ssy-av{flex:none;width:38px;height:38px;border-radius:50%;background:#E8F1F9;color:#0E2A47;font-weight:800;display:flex;align-items:center;justify-content:center;font-size:.85em}" +
    "#ss-yorumlar .ssy-one .ssy-av{background:rgba(255,255,255,.18);color:#fff}" +
    "#ss-yorumlar .ssy-ad{font-weight:700;line-height:1.2}" +
    "#ss-yorumlar .ssy-bilgi{font-size:.82em;color:#44566A;line-height:1.3}" +
    "#ss-yorumlar .ssy-one .ssy-bilgi{color:rgba(255,255,255,.8)}" +
    "#ss-yorumlar .ssy-sayac{display:none;text-align:center;margin-top:10px;font-size:.85em;color:#44566A}" +
    "@media (max-width:900px){#ss-yorumlar .ssy-izgara{grid-template-columns:repeat(2,1fr)}}" +
    "@media (max-width:700px){#ss-yorumlar{margin:32px auto}#ss-yorumlar h2{font-size:1.35em}" +
    "#ss-yorumlar .ssy-izgara{display:flex;overflow-x:auto;gap:12px;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:6px}" +
    "#ss-yorumlar .ssy-kart{flex:0 0 84%;scroll-snap-align:start}#ss-yorumlar .ssy-sayac{display:block}}";

  function yildizSvg(doc, dolu) {
    var ns = "http://www.w3.org/2000/svg";
    var s = doc.createElementNS(ns, "svg");
    s.setAttribute("viewBox", "0 0 24 24");
    s.setAttribute("aria-hidden", "true");
    var p = doc.createElementNS(ns, "path");
    p.setAttribute("d", "M12 2.5l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.5l-5.9 3.2 1.2-6.6L2.5 9.5l6.6-.9z");
    p.setAttribute("fill", dolu ? "#F2A900" : "#D8E4EF");
    s.appendChild(p);
    return s;
  }
  function el(doc, ad, sinif, metin) {
    var e = doc.createElement(ad);
    if (sinif) e.className = sinif;
    if (metin != null) e.textContent = metin;
    return e;
  }
  function gecerli(y) {
    return y && typeof y === "object" && typeof y.metin === "string" && y.metin.trim().length > 0 &&
      typeof y.ad === "string" && y.ad.trim().length > 0 && y.puan >= 1 && y.puan <= 5;
  }
  function ayYil(t, dil) {
    var m = /^(\d{4})-(\d{2})$/.exec(String(t || ""));
    if (!m) return "";
    var ay = AYLAR[dil][parseInt(m[2], 10) - 1];
    return ay ? ay + " " + m[1] : "";
  }

  function ciz(doc, dil, liste) {
    var kok = doc.getElementById("ss-yorumlar");
    if (!kok) return "yer-yok";
    var yorumlar = (liste || []).filter(gecerli);
    if (!yorumlar.length) {
      kok.style.display = "none";
      return "yorum-yok";
    }
    if (kok.getAttribute("data-ssy")) return "zaten-yapildi";
    kok.setAttribute("data-ssy", "1");
    var t = METIN[dil === "en" ? "en" : "tr"];
    var onde = yorumlar.filter(function (y) { return y.one === true; })[0];
    var sirali = onde ? [onde].concat(yorumlar.filter(function (y) { return y !== onde; })) : yorumlar.slice();

    var ust = el(doc, "div", "ssy-ust");
    var sol = doc.createElement("div");
    sol.appendChild(el(doc, "h2", "", t.baslik));
    sol.appendChild(el(doc, "p", "ssy-alt", t.alt));
    ust.appendChild(sol);
    var toplam = 0;
    sirali.forEach(function (y) { toplam += Math.round(y.puan); });
    var ort = Math.round((toplam / sirali.length) * 10) / 10;
    var ortKutu = el(doc, "div", "ssy-ort");
    ortKutu.appendChild(el(doc, "b", "", String(ort).replace(".", dil === "en" ? "." : ",")));
    var oy = doc.createElement("div");
    var yl = el(doc, "div", "ssy-yildiz");
    for (var i = 1; i <= 5; i++) yl.appendChild(yildizSvg(doc, i <= Math.round(ort)));
    oy.appendChild(yl);
    oy.appendChild(el(doc, "div", "", sirali.length + " " + t.yorum));
    ortKutu.appendChild(oy);
    ust.appendChild(ortKutu);

    var izgara = el(doc, "div", "ssy-izgara");
    izgara.setAttribute("role", "list");
    sirali.forEach(function (y, k) {
      var kart = el(doc, "article", "ssy-kart" + (k === 0 && onde ? " ssy-one" : ""));
      kart.setAttribute("role", "listitem");
      var yildiz = el(doc, "div", "ssy-yildiz");
      yildiz.setAttribute("role", "img");
      yildiz.setAttribute("aria-label", Math.round(y.puan) + " / 5");
      for (var s = 1; s <= 5; s++) yildiz.appendChild(yildizSvg(doc, s <= Math.round(y.puan)));
      kart.appendChild(yildiz);
      var metin = (dil === "en" && typeof y.metin_en === "string" && y.metin_en.trim()) ? y.metin_en : y.metin;
      var p = el(doc, "p", "ssy-metin", metin);
      kart.appendChild(p);
      if (metin.length > 220) {
        var d = el(doc, "button", "ssy-devam", t.devam);
        d.type = "button";
        d.setAttribute("aria-expanded", "false");
        d.addEventListener("click", function () {
          var acik = p.classList.toggle("ssy-acik");
          d.textContent = acik ? t.kapat : t.devam;
          d.setAttribute("aria-expanded", acik ? "true" : "false");
        });
        kart.appendChild(d);
      }
      var yz = el(doc, "div", "ssy-yazar");
      var bas = y.ad.replace(/[^A-Za-zÇĞİÖŞÜçğıöşü]/g, "").slice(0, 2).toLocaleUpperCase(dil === "en" ? "en" : "tr");
      yz.appendChild(el(doc, "div", "ssy-av", bas || "•"));
      var kim = doc.createElement("div");
      kim.appendChild(el(doc, "div", "ssy-ad", y.ad));
      var bilgi = [y.pazar, y.paket, ayYil(y.tarih, dil === "en" ? "en" : "tr")].filter(Boolean).join(" · ");
      if (bilgi) kim.appendChild(el(doc, "div", "ssy-bilgi", bilgi));
      yz.appendChild(kim);
      kart.appendChild(yz);
      izgara.appendChild(kart);
    });
    var sayac = el(doc, "div", "ssy-sayac", "1/" + sirali.length);
    sayac.setAttribute("aria-hidden", "true");
    izgara.addEventListener("scroll", function () {
      var k = izgara.children[0];
      if (!k) return;
      var adim = k.getBoundingClientRect().width + 12;
      var n = Math.min(sirali.length, Math.max(1, Math.round(izgara.scrollLeft / adim) + 1));
      sayac.textContent = n + "/" + sirali.length;
    }, { passive: true });

    kok.appendChild(ust);
    kok.appendChild(izgara);
    kok.appendChild(sayac);
    var st = doc.createElement("style");
    st.textContent = CSS;
    kok.appendChild(st);
    return "ok";
  }

  if (typeof window !== "undefined" && typeof document !== "undefined" && !window.__ssYorumTest) {
    var calistir = function () {
      try {
        var dil = (document.documentElement.getAttribute("lang") || "tr").toLowerCase().indexOf("en") === 0 ? "en" : "tr";
        ciz(document, dil, YORUMLAR);
      } catch (e) {}
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", calistir);
    else calistir();
  }
  if (typeof window !== "undefined") window.__ssYorumCiz = ciz;
})();
